module.exports = __webpack_public_path__ + "media/images/menu/m5-016835ee56c926ab251fb144850b0e76.JPG";